import { Icons } from '../assets/icons'
import { defineComponent, onMounted, ref } from 'vue'
import { Assets } from '../assets'
import { useRouter } from 'vue-router'

const currentPosition = ref('메인')
const observer = new IntersectionObserver(
  (items) => {
    items = items.filter(el => el.isIntersecting)
    if (items.length === 0) return

    items.sort((a, b) => a.intersectionRatio - b.intersectionRatio)
    currentPosition.value = items[0].target.id
  },
  {
    rootMargin: '20px 0px 0px 0px',
    threshold: [0.5],
  },
)

const Jumbotron = defineComponent({
  setup () {
    const router = useRouter()
    const elRef = ref<HTMLDivElement>()
    onMounted(() => {
      observer.observe(elRef.value)
    })
    return () => (
      <div
        class={`
          relative
          pt-24 pb-0 bg-[#F8F8F8]
          md:bg-transparent md:pb-24
        `}
        id="메인"
        ref={elRef}
      >
        <div
          class="absolute inset-0 bg-contain bg-left-bottom bg-no-repeat -z-10"
          style={{
            backgroundImage: `url(${Assets.jumbotron_background})`,
            backgroundSize: '110%',
          }}
        />
        <div class="flex flex-col items-center max-w-5xl mx-auto px-5 md:items-start">
          <div>
            <img src={Assets.snuh_logo} style={{ width: '165px' }} />
          </div>
          <div class="mt-7 text-sm text-[#245058]">
            디지털 정신건강 모니터링 시스템
          </div>
          <div class="mt-2 text-3xl text-[#245058] font-bold">
            연구참여자 모집공고
          </div>
          <div class="mt-3 text-sm font-bold text-center">
            디지털 정신건강 모니터링 시스템 개발 및 검증
          </div>
          <div class="text-sm text-[#282828] text-center">
            웹 / 모바일 기반 정신건강케어 서비스 제공을 목적으로
            <br />
            개발된 프로그램 [마인들링]의 효과성을 검증하고자 합니다.
          </div>
          <div class="mt-6">
            <button
              class="bg-[#245058] text-white font-bold flex px-2 py-3 items-center w-[168px] rounded-md cursor-pointer hover:bg-[#2F646D] md:w-[202px]"
              onClick={() =>
                router.push({
                  name: 'stage1',
                })
              }
            >
              <div>
                <img src={Icons.board} style={{ width: '23px' }} />
              </div>
              <div class="grow">참여하기</div>
              <div class="invisible">
                <img src={Icons.board} style={{ width: '23px' }} />
              </div>
            </button>
          </div>
        </div>
        <div class="absolute hidden md:flex bottom-4 left-1/2 -translate-x-1/2 text-[#245058] font-bold text-sm">
          <img src={Icons.finger} style={{ width: '20px' }} />
          <span class="ml-1">자세히보기</span>
        </div>
        <div
          class="py-36 bg-cover bg-bottom w-full md:hidden"
          style={{ backgroundImage: `url(${Assets.jumbotron_background})` }}
        ></div>
        <div
          v-show={currentPosition.value !== '메인'}
          class="fixed bottom-0 w-full md:hidden px-4 py-3 bg-white border-t"
        >
          <button
            class="bg-[#245058] text-white font-bold flex px-2 py-3 items-center w-full rounded-md cursor-pointer hover:bg-[#2F646D]"
            onClick={() =>
              router.push({
                name: 'stage1',
              })
            }
          >
            <div>
              <img src={Icons.board} style={{ width: '23px' }} />
            </div>
            <div class="grow">참여하기</div>
            <div class="invisible">
              <img src={Icons.board} style={{ width: '23px' }} />
            </div>
          </button>
        </div>
      </div>
    )
  },
})

const Navigation = defineComponent({
  setup () {
    return () => (
      <div class="border-y flex justify-center text-sm sticky top-0 bg-white">
        <a
          class={` border-b-[3px] pt-4 pb-3 mx-4 md:mx-10 ${
            currentPosition.value === '연구내용'
              ? 'border-b-[#245058] font-bold text-[#245058]'
              : 'border-b-transparent text-[#282828]'
          }`}
          href="#연구내용"
        >
          연구내용
        </a>
        <a
          class={` border-b-[3px] pt-4 pb-3 mx-4 md:mx-10 ${
            currentPosition.value === '진행내용'
              ? 'border-b-[#245058] font-bold text-[#245058]'
              : 'border-b-transparent text-[#282828]'
          }`}
          href="#진행내용"
        >
          진행내용
        </a>
        <a
          class={` border-b-[3px] pt-4 pb-3 mx-4 md:mx-10 ${
            currentPosition.value === '참여방법'
              ? 'border-b-[#245058] font-bold text-[#245058]'
              : 'border-b-transparent text-[#282828]'
          }`}
          href="#참여방법"
        >
          참여방법
        </a>
      </div>
    )
  },
})

const Title = defineComponent({
  setup () {
    return () => (
      <div class="pt-28 pb-40 px-5">
        <div class="max-w-xs mx-auto md:max-w-5xl">
          <img src={Assets.mobile_title} class="w-full md:hidden" />
          <img src={Assets.pc_title} class="w-full hidden md:block" />
        </div>
      </div>
    )
  },
})
const Introduce = defineComponent({
  setup () {
    const elRef = ref<HTMLDivElement>()
    onMounted(() => {
      observer.observe(elRef.value)
    })
    return () => (
      <div class="bg-[#EAF0F2] pt-24 pb-20 px-5" id="연구내용" ref={elRef}>
        <div class="max-w-xs mx-auto md:max-w-5xl">
          <img src={Assets.mobile_introduce} class="w-full md:hidden" />
          <img src={Assets.pc_introduce} class="w-full hidden md:block" />
        </div>
      </div>
    )
  },
})
const Body = defineComponent({
  setup () {
    const elRef = ref<HTMLDivElement>()
    onMounted(() => {
      observer.observe(elRef.value)
    })
    return () => (
      <div
        class="bg-cover bg-center pt-24 pb-20 px-5"
        id="진행내용"
        ref={elRef}
      >
        <div class="max-w-xs mx-auto md:max-w-5xl">
          <img src={Assets.mobile_body} class="w-full md:hidden" />
          <img src={Assets.pc_body} class="w-full hidden md:block" />
        </div>
      </div>
    )
  },
})
const Reward = defineComponent({
  setup () {
    return () => (
      <div
        class="bg-cover bg-center pt-24 pb-20 px-5"
        style={{ backgroundImage: `url(${Assets.reward_background})` }}
      >
        <div class="max-w-xs mx-auto md:max-w-5xl">
          <img src={Assets.mobile_reward} class="w-full md:hidden" />
          <img src={Assets.pc_reward} class="w-full hidden md:block" />
        </div>
      </div>
    )
  },
})
const Progress = defineComponent({
  setup () {
    const elRef = ref<HTMLDivElement>()
    onMounted(() => {
      observer.observe(elRef.value)
    })
    const router = useRouter()
    return () => (
      <div class="bg-[#F5F6F8] pt-24 pb-20 px-5" id="참여방법" ref={elRef}>
        <div class="max-w-xs mx-auto md:max-w-2xl">
          <img src={Assets.mobile_progress} class="w-full md:hidden" />
          <img src={Assets.pc_progress} class="w-full hidden md:block" />
        </div>
        <div class="text-center mt-14 hidden md:block">
          <button
            class="bg-[#245058] text-white font-bold px-2 py-4 items-center w-[230px] rounded-md"
            onClick={() =>
              router.push({
                name: 'stage1',
              })
            }
          >
            <div class="grow">설문 참여하기</div>
          </button>
        </div>
      </div>
    )
  },
})

export default defineComponent({
  setup () {
    return () => (
      <div>
        <Jumbotron />
        <Navigation />
        <Title />
        <Introduce />
        <Body />
        <Reward />
        <Progress />
      </div>
    )
  },
})
